// extracted by mini-css-extract-plugin
export var fileExt = "_uz-8";
export var fileIcon = "_uz-6";
export var fileLink = "_uz-5";
export var fileName = "_uz-7";
export var image = "_uz-1";
export var imageError = "_uz-3";
export var imageErrorIcon = "_uz-4";
export var imageLink = "_uz-0";
export var imageLoaded = "_uz-2";